export default __webpack_public_path__ + "static/media/ads-bg2.cdd3bd00.jpg";